module.exports = __webpack_public_path__ + "media/images/cliparts/24-7 support 7-00830f3a89106f44a28cc641c39e68a8.svg";